import script from "./newPasswordForm.vue?vue&type=script&setup=true&lang=js"
export * from "./newPasswordForm.vue?vue&type=script&setup=true&lang=js"

import "./newPasswordForm.vue?vue&type=style&index=0&id=c9aea6b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9aea6b8"]])

export default __exports__